import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import React from "react";

const OfferLetterPopup = ({
  setShow,
  show,
  title = "Offer Letter Acceptance",
  message = "Please acknowledge your offer letter to proceed further with legal documentation.",
}) => {
  return (
    <Modal
      title=""
      className="p-0 custom_modal__"
      centered
      open={show}
      width={350}
      closeIcon={<CloseOutlined style={{ color: "white", fontSize: "16px" }} />}
      footer={null}
      onCancel={() => setShow(false)}
    >
      <div>
        <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
          <h5
            className="modal-title text-white text-capitalize font-weight-bold"
            style={{ fontSize: "18px", fontWeight: 400 }}
          >
            {title}
          </h5>
        </div>
        <div className="row py-3 px-4 ">
          <div className="w-100">
            <div className="col-12" style={{ paddingTop: "10px" }}>
              <div className="d-flex __custom_row">
                <div style={{ flex: "1 1" }}>
                  <h6 className="__custom_heading text-center">
                    {message}
                  </h6>
                  <div
                    className="d-flex justify-content-center gap-1"
                    style={{
                      marginTop: "1.5rem",
                    }}
                  >
                    <button
                      className={`btn btn-primary`}
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      Okay
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OfferLetterPopup;
